import React, { useMemo, useState } from 'react';
import { BsPencilSquare } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Box, Grid, GridItem, Icon, IconButton, Input, Text } from '@chakra-ui/react';
import FuzzySearch from 'fuzzy-search';

import { showModal } from '../../redux/modules/modal';
import { useMeCompanies } from '../../services/user-service';
import colors from '../../styles/theme/foundation/colors';

import EditCompanyModal from './EditCompanyModal';

const PinsAdminCompaniesTable = () => {
  const dispatch = useDispatch();
  const { data: companies, isLoading } = useMeCompanies();
  const [search, setSearch] = useState('');
  const history = useHistory();

  const companyList = useMemo(() => {
    if (isLoading) {
      return [];
    }

    if (search === '') {
      return companies.slice(0, 50);
    }

    const fuzzySearch = new FuzzySearch(companies, ['companyName', 'companyId', 'shortName', 'companyAlias'], { caseSensitive: false });
    return fuzzySearch.search(search).slice(0, 50);
  }, [companies, isLoading, search]);

  const handleClick = companyId => history.push(`/companies/${companyId}/departments`);

  const handleEditCompany = company => {
    dispatch(showModal(
      () => (<EditCompanyModal company={company} />),
      {
        title: 'Edit Company Details',
        size: '4xl'
      }
    ));
  };

  return (
    <Box bg={colors.white} maxH="700px" overflowY="auto" w="1050px">
      <Text textStyle="displayXs">PINS Admin</Text>

      <Text textStyle="bodyLg">Select a company</Text>

      <Box justifyContent="flex-end" textAlign="right">
        <Input placeholder="Search" w="300px" onChange={e => setSearch(e.target.value)} />
      </Box>

      {isLoading && <Text>Loading...</Text>}

      <Box p={4} textAlign="left">
        <Grid
          gap={6}
          gridTemplateColumns="repeat(12, 1fr);"
        >
          <GridItem alignSelf="center" colSpan={1} justifySelf="left" ml={2} textStyle="bodyLg500">ID</GridItem>
          <GridItem alignSelf="center" colSpan={5} justifySelf="left" ml={2} textStyle="bodyLg500">Name</GridItem>
          <GridItem alignSelf="center" colSpan={2} justifySelf="left" ml={2} textStyle="bodyLg500">Company Alias</GridItem>
          <GridItem alignSelf="center" colSpan={2} justifySelf="left" ml={2} textStyle="bodyLg500">Short Name</GridItem>
          <GridItem alignSelf="center" colSpan={2} justifySelf="left" ml={2} textStyle="bodyLg500">Edit Company</GridItem>
        </Grid>

        {companyList.map(c => (
          <Grid
            gap={6}
            gridTemplateColumns="repeat(12, 1fr);"
            key={c.companyId}
            my={4}
          >
            <GridItem
              _hover={{ color: colors.primaryScale['900'], textDecoration: 'underline' }}
              alignSelf="center"
              colSpan={1}
              cursor="pointer"
              justifySelf="left"
              ml={2}
              onClick={() => handleClick(c.companyId)}
            >
              {c.companyId}
            </GridItem>
            <GridItem
              _hover={{ color: colors.primaryScale['900'], textDecoration: 'underline' }}
              alignSelf="center"
              colSpan={5}
              cursor="pointer"
              justifySelf="left"
              ml={2}
              onClick={() => handleClick(c.companyId)}
            >
              {c.companyName}
            </GridItem>
            <GridItem
              _hover={{ color: colors.primaryScale['900'], textDecoration: 'underline' }}
              alignSelf="center"
              colSpan={2}
              cursor="pointer"
              justifySelf="left"
              ml={2}
              onClick={() => handleClick(c.companyId)}
            >
              {c.companyAlias}
            </GridItem>
            <GridItem
              _hover={{ color: colors.primaryScale['900'], textDecoration: 'underline' }}
              alignSelf="center"
              colSpan={2}
              cursor="pointer"
              justifySelf="left"
              ml={2}
              onClick={() => handleClick(c.companyId)}
            >
              {c.shortName}
            </GridItem>
            <GridItem
              _hover={{ color: colors.primaryScale['900'], textDecoration: 'underline' }}
              alignSelf="center"
              colSpan={2}
              cursor="pointer"
              justifySelf="left"
              ml={2}
            >
              <IconButton
                aria-label="edit-company-icon"
                icon={<Icon as={BsPencilSquare} boxSize="18px" />}
                size="xs"
                variant="textGrey"
                onClick={() => handleEditCompany(c)}
              />
            </GridItem>
          </Grid>
        ))}

      </Box>

    </Box>
  );
};

export default PinsAdminCompaniesTable;
